import axios from 'services/http';
import { baseUrl } from 'services/http/base';

export const getUserInfo = async <T>(config?: object) => {
  return axios.get<T>(`${baseUrl}/uapi/v1/uc/user/info`, {}, config);
};
